import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/google-claims',
    component: () => import('@/views/GoogleClaims/Index.vue'),
    meta: {
      requiresAuth: true,
    }
  },
]

export default routes;